import { List } from "../../services/faq.services";
import { useState, useEffect } from "react";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    List()
      .then((response) => {
        if (response?.success) {
          console.log(response);
          setFaqs(response?.data?.faqs || []);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  return (
    <div className="main-content">
      {/* Search & Export */}
      <div className="support-part pb-4">
        <div className="card-box">
          <div className="container text-center mb-4">
            <h2 className="h3-headline">Frequently asked questions</h2>
            <p className="body-5">Find quick answers to the most common questions.</p>
          </div>
          <section className="w-100 accordion section-padding">
            <div className="container">
              <div className="accordion" id="faqAccordion">
                {faqs.length > 0 ? (
                  faqs.map((faq, index) => (
                    <div className="accordion-item" key={faq._id}>
                      <h2 className="accordion-header">
                        <button className={`accordion-button ${index === 0 ? "" : "collapsed"} sub-2 m-0`} type="button" data-bs-toggle="collapse" data-bs-target={`#faq-${index}`}>
                          {faq.title}
                        </button>
                      </h2>
                      <div id={`faq-${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`} data-bs-parent="#faqAccordion">
                        <div className="text-color">{faq.description}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">No FAQs available.</div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
